import React, { Component, useState } from "react";
import IOrder from "../../../../../models/IOrder";
import IOrder_Item from "../../../../../models/IOrder_Item";
import IOwTableCols from "../../../../../models/IOwTableCols";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import OrderStatesEnum from "../../../../../models/OrderStatesEnum";
import UserService from "../../../../../services/UserService";
import AddressDisplay from "../../../../shared/AddressDisplay/AddressDisplay";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTable from "../../../../shared/OwTable/OwTable";
import * as _ from "lodash-es";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {
    order: IOrder;
};

export const OrdersDetailReportOrderRow = (props: Props) => {
    const { supplierModel, userModel } = useAppContextNonNull();

    const renderCategoryFn = (row: IOrder_Item) => {
        return row?.Catalog_Item?.Category ? row?.Catalog_Item?.Category?.name : null;
    };

    const getDefaultColumns = (): IOwTableCols[] => {
        let hasCategories = false;

        for (const item of props.order.Order_Items) {
            if (item?.Catalog_Item?.Category) {
                hasCategories = true;
                break;
            }
        }

        const columns: IOwTableCols[] = [
            {
                title: "no",
                valueProp: "item_no",
            },
            {
                title: "sku",
                valueProp: "Catalog_Item",
                valueSubProp: "sku",
            },
            {
                title: "description",
                valueProp: "Catalog_Item",
                valueSubProp: "description",
            },
        ];

        if (hasCategories) {
            columns.push({
                title: "category",
                valueProp: "",
                renderFn: renderCategoryFn,
                renderFnEmitsRow: true,
            });
        }

        columns.push({
            title: "order_qty",
            valueProp: "qty",
        });

        return columns;
    };

    const [columns, setColumns] = useState<IOwTableCols[]>(getDefaultColumns());

    const processDate = (dateStr: string) => {
        if (!dateStr.length) {
            return null;
        }

        return UserService.parseDate(dateStr);
    };

    const getOrderState = () => {
        const state = props.order.order_state_id;

        switch (state) {
            case OrderStatesEnum.CONFIRMED:
                return "Confirmed";
        }

        return _.startCase((props.order?.Order_State?.name || "").toLowerCase());
    };

    return (
        <div className="OrdersDetailReportOrderRow mb-5">
            <div className={"row border m-1 p-1"}>
                <div className={"col-3"}>
                    <OwLabel className={"me-2"} title={"order"} noBottomMargin={true} isBold={true} />
                    {props.order.name}
                </div>
                <div className={"col-3"}>
                    <OwLabel className={"me-2"} title={"status"} noBottomMargin={true} isBold={true} />
                    {getOrderState()}
                </div>
                <div className={"col-3"}>
                    <OwLabel className={"me-2"} title={"created_at"} noBottomMargin={true} isBold={true} />
                    {processDate(props.order.created_at as string)}
                </div>
                <div className={"col-3"}>
                    <OwLabel className={"me-2"} title={"submitted_at"} noBottomMargin={true} isBold={true} />
                    {processDate(props.order.submit_date || "")}
                </div>
                {props.order?.Category?.name && (
                    <div className={"col-3"}>
                        <OwLabel className={"me-2"} title={"order_category"} noBottomMargin={true} isBold={true} />
                        {props.order.Category.name}
                    </div>
                )}
            </div>

            <div className={"row mt-2 p-2"}>
                <div className={"col-12"}>
                    <OwLabel title={"created_by"} className={"me-2"} noBottomMargin={true} isBold={true} />
                    <span className={"me-2"}>{props.order?.User?.name}</span>
                    <span>{props.order?.User?.email}</span>
                </div>
            </div>

            <div className={"mt-4 mb-4 border d-inline-flex flex-column p-2"}>
                <div className={"border-bottom pb-2 mb-2"}>
                    <OwLabel
                        className={"me-2"}
                        isBold={true}
                        noBottomMargin={true}
                        title={"vendor"}
                        supplierModel={supplierModel}
                        isSupplierVendorOverride={true}
                    />
                    {props.order?.Vendor?.name}
                </div>
                {supplierModel.has_client_module && props.order?.Client && (
                    <div className={"border-bottom pb-2 mb-2"}>
                        <OwLabel isBold={true} noBottomMargin={true} title={"client"} className={"me-2"} />
                        {props.order?.Client?.name}
                    </div>
                )}
                <div>
                    <OwLabel isBold={true} noBottomMargin={true} title={"ship_to"} />
                    <div className={"ms-4"}>
                        <AddressDisplay address={props.order.Ship_To || props.order?.Vendor?.Ship_To} />
                    </div>
                </div>
            </div>

            <div>
                <OwTable
                    columns={columns}
                    dataSet={props.order.Order_Items || []}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    dataFetch={false}
                    initialData={false}
                />
            </div>
        </div>
    );
};

export default OrdersDetailReportOrderRow;
